<div class="page-title-bar" [ngStyle]="imageUrl ? {'background-image': 'url(' + imageUrl+ ')'} : ''">
  <div class="container">
    <h1 class="mb-3"> {{heading}}</h1>
    <p class="lead text-xxl"> {{subHeading}} </p>
  </div>
</div>
